import React from 'react'

const Broshure = () => {
  return (
    <div>
      <h1 className='py-5 text-center'>Broshure</h1>
    </div>
  )
}

export default Broshure
